import {Component, Injector, OnInit} from '@angular/core';
import {BaseComponent} from '../../../base.component';
import {MatDialogRef} from '@angular/material/dialog';
import {AddOrUpdateSettingsOptions} from './options/add-or-update-settings.options';
import {DataResponse} from '../../../../network/service/data.response';
import {SnackBarUtil} from '../../../../util/snack.bar.util';
import {RequestType} from '../../../../enums/request.type';

@Component({
  selector: 'app-add-or-update-settings',
  standalone: false,
  templateUrl: './add-or-update-settings.component.html',
  styleUrl: './add-or-update-settings.component.scss'
})
export class AddOrUpdateSettingsComponent extends BaseComponent implements OnInit {
  addOrUpdateSettingsOptions = new AddOrUpdateSettingsOptions();
  title?: any;
  key?: any;
  isActive?: any;
  branchId?: any;
  staffIds?: any;
  staffs?: any = [];
  selectedBranch?: any;
  keyOptions = [
    {
      Value: 'SEND_SMS_TO_ADMINS_FOR_NEW_ORDER',
      Title: 'ارسال پیامک سفارش جدید به ادمین ها'
    },
    {
      Value: 'SEND_SMS_TO_CLIENTS_FOR_NEW_ORDER',
      Title: 'ارسال پیامک سفارش جدید به کاربر ها'
    },
    {
      Value: 'SEND_PUSH_NOTIFICATION_TO_CLIENTS_FOR_NEW_ORDER',
      Title: 'ارسال پوش نوتیفیکیشن سفارش جدید به ادمین ها'
    }
  ];

  constructor(injector: Injector, private readonly matDialogRef: MatDialogRef<AddOrUpdateSettingsComponent>) {
    super(injector);
  }

  override ngOnInit() {
    super.ngOnInit();
    this.title = this.addOrUpdateSettingsOptions.setting.Title;
    this.key = this.keyOptions.find((k: any) => k.Value === this.addOrUpdateSettingsOptions.setting.Key);
    this.isActive = this.addOrUpdateSettingsOptions.setting.IsActive;
    this.branchId = this.addOrUpdateSettingsOptions.setting.BusinessId;
    this.selectedBranch = this.addOrUpdateSettingsOptions.setting.Business;
    if (this.key?.Value === 'SEND_SMS_TO_ADMINS_FOR_NEW_ORDER' || this.key?.Value === 'SEND_PUSH_NOTIFICATION_TO_CLIENTS_FOR_NEW_ORDER') {
      this.staffIds = this.addOrUpdateSettingsOptions.setting.Value.StaffIds ?? [];
      if (this.staffIds) {
        this.serviceApi.getUsers(undefined, undefined, 'Business_Business', RequestType.ALL, {
          Filter: {
            Values: [{
              Field: 'UserId',
              Type: 'IN',
              Value: this.staffIds
            }],
            Type: 'AND'
          }
        }).subscribe((res: DataResponse<any>) => {
          if (res.success) {
            this.staffs = res.data;
          }
        });
      }
    }
  }

  override loadOnline() {
    super.loadOnline();
  }

  onKeySelect(type?: any) {
    switch (type.Value) {
      case 'SEND_SMS_TO_ADMINS_FOR_NEW_ORDER':
      case 'SEND_PUSH_NOTIFICATION_TO_CLIENTS_FOR_NEW_ORDER':
        this.staffIds = [];
        break;
    }
    this.key = type;
  }

  noAction() {
    this.matDialogRef.close();
  }

  onSubmitClicked() {
    (this.addOrUpdateSettingsOptions.setting.SettingId !== undefined ? this.serviceApi.updateSettings(this.addOrUpdateSettingsOptions.setting.SettingId, {
      Value: {
        StaffIds: this.staffIds
      },
      IsActive: this.isActive
    }) : this.serviceApi.createSettings({
      Title: this.key.Title,
      Key: this.key.Value,
      Value: {
        StaffIds: this.staffIds
      },
      IsActive: this.isActive,
      BusinessId: this.branchId
    })).subscribe((res: DataResponse<any>) => {
      if (res.success) {
        this.addOrUpdateSettingsOptions.onInsertOrUpdateFinished();
        this.noAction();
      } else {
        SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
      }
    });
  }
}
